<script setup lang="ts">
import { usePage } from "@inertiajs/vue3";
import { PagePropsInterface } from "@interfaces/PagePropsInterface.js";
import { computed, Ref } from "vue";
import { trans } from 'laravel-vue-i18n'

let page = usePage<PagePropsInterface>();

let isReseller: Ref<boolean> = computed(() => {
    return page.props.reseller;
});

let getText = computed((): string => {
    return trans('sections.partner');
});
</script>

<template>
    <section id="layouts-section-partner-banner">
        <p v-html="getText" class="container"></p>
    </section>
</template>
<style lang="scss">
@use "@scss/layouts/sections/partner-banner";
</style>
